/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchFiltersSchemaMinDegree = typeof SearchFiltersSchemaMinDegree[keyof typeof SearchFiltersSchemaMinDegree];


export const SearchFiltersSchemaMinDegree = {
  none: 'none',
  associates: 'associates',
  bachelors: 'bachelors',
  masters: 'masters',
  doctorate: 'doctorate',
  phd: 'phd',
} as const;
